import { GraphQLErrorExtensions, GraphQLFormattedError } from 'graphql';

import { DisplayableError } from '../graphql/schema';

type NestedErrorObject = {
  [key: string]: NestedErrorObject | string;
};

type GraphQLExtensionsWithProblems = GraphQLErrorExtensions & {
  problems: { explanation: string; path: string[] }[];
};

const convertDisplayableErrors = (errors: DisplayableError[]) =>
  errors.reduce<NestedErrorObject>((acc, error) => {
    const { path } = error;
    let currentObject = acc;

    path.forEach((field: string, index: number) => {
      if (index === path.length - 1) {
        currentObject[field] = error.message;
      } else {
        currentObject[field] = currentObject[field] || {};
        currentObject = currentObject[field] as NestedErrorObject;
      }
    });

    return acc;
  }, {});

const convertGraphQLErrors = (errors: readonly GraphQLFormattedError[]) => {
  return errors.reduce<NestedErrorObject>((acc, err) => {
    const extensions = err.extensions as GraphQLExtensionsWithProblems;
    const [{ path, explanation }] = extensions.problems;

    let currentObject = acc;

    path.forEach((field, index) => {
      if (index === path.length - 1) {
        currentObject[field] = explanation;
      } else {
        currentObject[field] = currentObject[field] || {};
        currentObject = currentObject[field] as NestedErrorObject;
      }
    });

    return acc;
  }, {});
};

export { convertDisplayableErrors, convertGraphQLErrors };
